'use client';

import { Link, Text, useHrefOptions } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

import { DeviceError404Animation } from '../../animations';

interface IPageNotFoundProps {
  ctaText: TTextLocalized;
  subtitle: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * This component renders a custom error message for a 404 page.
 */
export function PageNotFound({ ctaText, subtitle, title }: IPageNotFoundProps) {
  const { homePath } = useHrefOptions();

  return (
    <div className="mx-auto px-4 text-center">
      <div className="mx-auto flex flex-col items-center py-8">
        <DeviceError404Animation className="mx-auto my-12 h-56 w-56" />

        <h1
          className="
            mt-4 text-xl font-normal tracking-tight text-red-700
            dark:text-red-300 sm:text-xl
          "
        >
          <Text text={title} />
        </h1>
        <p className="my-8 font-light text-red-900  dark:text-red-200">
          <Text text={subtitle} />
        </p>

        <Link
          aria-label="Go back to home"
          className="form-btn w-auto"
          href={`/${homePath}`}
        >
          <Text text={ctaText} />
        </Link>
      </div>
    </div>
  );
}
